
import { getWebsiteID } from "/lib/common-functions"
import { useCookies } from "react-cookie"
import { useForm } from "react-hook-form";
import { loadScript } from '/lib/services/helpers/loadscript';
import { ChatAssistanceInitiate } from '/lib/ga';
import { EventCommonObj } from '/lib/services/helpers/eventCommonObject';
import { useEffect, useState } from 'react';

export const useContactUs = () => {
    const [error, setError] = useState("");
    const [showLoader, setShowLoader] = useState(false);
    const [cookie, setCookie] = useCookies([])
    const [scriptLoaded, setScriptLoaded] = useState(true);
    const [state, setState] = useState({
        open: true,
        vertical: 'top',
        horizontal: 'center',
    });
    const { vertical, horizontal, open } = state;
    const eventCommonObj = EventCommonObj({}, cookie);
    const website_id = getWebsiteID(cookie);
    const phoneRegExp = (website_id == 1) ? /^[6-9]\d{9}$/ : /^[0-9]\d{2,14}$/;

    const saveContact = async (fields) => {
        const response = await fetch("/api/contact", {
            method: "POST",
            body: JSON.stringify({ fields }),
            headers: {
                "Content-Type": "application/json",
            },
        });
        const data = await response.json();
        return !response.ok ? data : data;
    };

    const handleSnackClose = () => {
        setState({ ...state, open: false });
    };

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        defaultValues: {
            fullName: '',
            email: '',
            country: '',
            message: '',
            telephone: ''
        }
    });

    const onSubmit = data => {
        setShowLoader(true)

        const response = async () => {
            try {
                const tmp = await saveContact(data);
                setShowLoader(false)
                if (tmp.message) {
                    setError(tmp.message);
                    setState({ ...state, open: true });
                } else {
                    setError(tmp.success);
                    setState({ ...state, open: true });
                }
            } catch (error) {
                console.log('error in contact us form', error);
                setShowLoader(false)
            }
        };
        response()
    };

    const openWidget = () => {
        if (window.fcWidget && document.getElementById('fc_frame')) {
          document.getElementById('fc_frame').style.visibility = 'visible';
          window?.fcWidget.open()
        }
      }

    const loadScriptAsync = () => {
        return new Promise((resolve, reject) => {
            if (scriptLoaded) {
                loadScript('https://wchat.freshchat.com/js/widget.js')
                    .then(() => {
                        return new Promise((res, rej) => {
                            if (fcWidget.isLoaded()) {
                                res();
                            }
                            fcWidget.on('widget:loaded', () => {
                                res();
                            })
                        })
                    }).then(() => {
                        resolve();
                    })
                    .catch((error) => {
                        console.error('Error loading script:', error);
                        setShowLoader(false);
                        reject(error);
                    });
            } else {
                resolve();
            }
        });
    };

    useEffect(() => {
        window.openWidgetContact = async function () {
            try {
                setShowLoader(true);
                await loadScriptAsync();
                ChatAssistanceInitiate(eventCommonObj)
                setShowLoader(false);
                openWidget()
            } catch (error) {
                console.error('Error loading script:', error);
                setShowLoader(false);
            }
        };
    }, []);

    return {
        showLoader,
        error,
        vertical,
        horizontal,
        open,
        errors,
        website_id,
        phoneRegExp,
        handleSnackClose,
        handleSubmit,
        onSubmit,
        register,
    }

}

